import { GAME_ID, REDUX_ACTIONS } from 'a/bookClub/data/constants';

const initialState = {
  highestLevelUnlocked: 0,
  levelCount: 24,
};

const gameDetailsReducer = (state = initialState, { gameId, type, payload }) => {
  if (type === 'SELECT_ACTIVITY' && payload.activity === GAME_ID) {
    return initialState;
  }
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_COUNT: {
      return {
        ...state,
        levelCount: payload.levelCount,
      };
    }
    case REDUX_ACTIONS.MASTER_LEVEL: {
      const levelIndex = payload;
      return {
        ...state,
        // You cannot unlock any higher than the last level's index
        highestLevelUnlocked: levelIndex + 1 < state.levelCount ? levelIndex + 1 : levelIndex,
      };
    }
    default:
      return state;
  }
};

export default gameDetailsReducer;
